<script setup>

import {onMounted} from "vue";

defineProps({
    title: String,
    content: String,
    classes: String,
    isDraft: Boolean
})

const wrapImage = (img) => {
    const wrapper = document.createElement('div');
    wrapper.classList = img.classList;
    const imageText = document.createElement('div');
    imageText.innerText = img.alt;
    img.parentNode.insertBefore(wrapper, img);
    img.classList.add('mb-0');
    wrapper.appendChild(img);
    wrapper.appendChild(imageText)
    imageText.classList.add('mt-4', 'mb-8', 'text-xs', 'text-center');
};

onMounted(() => {
    document.querySelectorAll('article img[alt]').forEach((img) => {
        wrapImage(img);
    })
})

</script>

<template>
    <article :class="classes + ' prose prose-h1:text-3xl lg:prose-h1:text-4xl dark:prose-invert'">
        <h1 v-html="title"></h1>
        <alert v-if="isDraft" data-type="warning">Черновик</alert>
        <div v-html="content"></div>
    </article>
</template>
